import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";

import { Svg } from "./Svg";
import { mdiChevronDown } from "@mdi/js";

const ButtonStyle = styled.button`
    margin: 0;
    width: 18px;
    height: 18px;
    padding: 0px;
    border: none;
    background: none;
`;

const MenuStyle = styled.div`
    z-index: 999;
    position: absolute;
    box-shadow: 0 4px 5px 3px rgba(0, 0, 0, 0.2);
    background-color: ${props => props.theme.white};
    border: 1px solid ${props => props.theme.greyLight};
    >ul {
        list-style: none;
        padding: 10px 5px;
        >li {
            display: flex;
            font-size: 14px;
            cursor: pointer;
            padding: 10px 40px 10px 20px;
            color: ${props => props.theme.black};
            background-color: ${props => props.theme.white};
            &:hover {
                color: ${props => props.theme.white};
                background-color: ${props => props.theme.primaryLight};
            }
            >span {
                margin-left: 10px;
            }
        }
    }
`;

export const Option = props => <>{props.children}</>;

export const DropdownCaret = React.memo(props => {

    const { loading, children } = props;
    const [show, setShow] = useState(false);
    const [availableOptions, setAvailableOptions] = useState([]);

    const node = useRef(null);

    useEffect(() => {
        document.addEventListener("mousedown", onClickOutside);
        return () => {
            document.removeEventListener("mousedown", onClickOutside);
        };
    }, []);

    useEffect(() => {
        if (children === undefined) {
            return;
        }
        const entries = [children]
            .flatMap(child => (Array.isArray(child) ? child : [child]))
            .filter(child => child !== undefined)
            .filter(child => child.type === Option)
            .map(child => child.props);
        setAvailableOptions(entries);
    }, [children]);

    const onClick = () => {
        setShow(!show);
    };

    const onClickOption = (event, option) => {
        option.onClick(event);
        setShow(!show);
    };

    const onClickOutside = event => {
        if (node.current.contains(event.target)) {
            return;
        }
        setShow(false);
    };

    return (
        <div>
            <div ref={node}>
                <ButtonStyle onClick={event => onClick(event)} >
                    <Svg path={mdiChevronDown} loading={loading} size="18" />
                </ButtonStyle>
                {show && !loading &&
                    <MenuStyle>
                        <ul>
                            {availableOptions.map((option, index) =>
                                option.disabled !== true &&
                                <li key={index}
                                    onClick={event => onClickOption(event, option)}>
                                    <Svg path={option.svgIcon} size="16" />
                                    <span>{option.children}</span>
                                </li>

                            )}
                        </ul>
                    </MenuStyle>
                }
            </div>
        </div>
    );
});